// extracted by mini-css-extract-plugin
export default {"date-picker-calendar-container":"datepicker_date-picker-calendar-container__XRYNO","react-calendar__tile--now":"datepicker_react-calendar__tile--now__a3yVS"};